module.exports = __webpack_public_path__ + "img/jianshengzheng.e22a897c.png";